import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const SyntheticBiologyWorkshop = () => {
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>High School Synthetic Biology Workshop</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              High School Synthetic Biology Workshop
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={['SyntheticBiologyWorkshop', 'Proper', 'COVID']}
              currentClassName="active">
              <li><a href="#SyntheticBiologyWorkshop">High School Synthetic Biology Workshop with The Chinese University of Hong Kong</a></li>

            </Scrollspy>
            
          </div>

        </div>
        <div className="main_lab_style">
          <section id="SyntheticBiologyWorkshop">
            
          <h1>
              High School Synthetic Biology Workshop with The Chinese University of Hong Kong
          </h1>
          
          <p>
              We partnered with the Chinese University of Hong Kong to organize synthetic biology workshops for high schools, both inside and Hong Kong. As both of our teams have closely aligned objectives to fight against the global prominent disease that is cancer, we believe that it is necessary to increase the awareness of diverse communities from a wide range of demographics on these topics. Hence, we do not only limit ourselves to Hong Kong high schools. Instead, we provide an online option for interested high schools outside Hong Kong. We believe that education on crucial topics such as health issues, especially global and prevalent health issues, should not only be limited to certain groups due to various barriers. This online international workshop event is one of our team’s efforts to overcome geographical barrier on scientific and health education.
          </p>

          <p>
              This event targets specifically high school students as they are still in the midst of exploring their interests, and hence may be interested to delve further, contribute, and form a well-informed and critical mind towards the world of synthetic biology.
          
          </p>

          <p>
            <h1>
                OBJECTIVES OF EVENT:
            </h1>
              <ul>
                <li>Provide an opportunity for cross-cultural networking</li>
                <li>Educate students on synthetic biology</li>
                <li>Introduce synthetic biology as a viable career option</li>
                <li>Educate students about iGEM</li>
              </ul>
          </p>
            
            <p style={{padding:30}}>
              <h1 style={{textAlign:"center"}}>Our team drafted a proposal and conducted ZOOM Meetings with a number of schools around the world who showed interest in our workshop.</h1>
            
              <br />
            
              <img src="https://static.igem.wiki/teams/4154/wiki/assets/screenshot-2022-09-24-at-2-11-16-pm.png" alt="" />

              <br />

              <img src="https://static.igem.wiki/teams/4154/wiki/assets/screenshot-2022-09-24-at-1-18-11-pm.png" alt="" />

            </p>
          </section>
          
        </div>
      </section>
    </div>
  );
}

export default SyntheticBiologyWorkshop;
